import { render, staticRenderFns } from "./pendpay.vue?vue&type=template&id=fe34908c"
import script from "./pendpay.vue?vue&type=script&lang=js"
export * from "./pendpay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports